<template>
    <Card title="Alerts" >
        <vue-loading :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
        <div v-if="loaded">
      <div class="row">
        <div class="column">
          <!-- Keep MetricGraph -->
          <MetricGraph :metrics='metrics'
            :name='"Total Alerts"'
            :date='date'
            :period='period'
            :lastUpdate='lastUpdate'
            :metricProperties=metricProperties
            :metricProperty=metricProperty
            v-on:updateMetric='updateMetric' />
        </div>
      </div>

      <div class="row">
        <div class="column">
           <div id="alerts-priority" class="alerts">
              <AlertsPriorityList :alerts='alerts' />
           </div>
        </div>
      </div>
    </div>

    <router-link
      :to="`/${id}/alerts`"
      class="inline-flex items-center px-5 py-3 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200"
    >
      View Detailed Alerts Report
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="ml-2 h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M5 12h14M12 5l7 7-7 7" />
      </svg>
    </router-link>

    </Card>

</template>

<script>
import Card from '../Card.vue'
import HTTP from '@/common/http'
import MetricGraph from '@/components/MetricGraph'
import AlertsPriorityList from '@/components/Alerts/AlertsPriorityList'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'
export default {
  name: 'AlertsCard',
  components: {
    Card,
    MetricGraph,
    AlertsPriorityList,
    VueLoading
  },
  props: [
    'id'
  ],
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  data () {
    return {
      alerts: {}, // Needed for AlertsPriorityList
      metrics: [], // Needed for MetricGraph
      loading: false,
      loaded: false, // Simple flag to wait for initial data
      period: 'week', // Needed for MetricGraph & API calls
      date: null, // Needed for MetricGraph & API calls
      lastUpdate: 'unknown', // Needed for MetricGraph
      metricProperties: [ // Needed for MetricGraph
        'total',
        'critical',
        'downgraded',
        'warning',
        'task',
        'info'
      ],
      metricProperty: 'total' // Needed for MetricGraph
    }
  },
  methods: {

    getReport: function () {
      // No longer setting loading=true here, rely on getMetrics initial load
      // this.loading = true; // Potentially remove if getMetrics handles initial load
      HTTP.get(`/alerts/summary/${this.activeType}/${this.id}/${this.period}/${this.date}`)
        .then((response) => {
          this.alerts = response.data.alerts // Only keep what's needed
          // Removed assignments for downtime, timeline, incidents
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get alert summary : ${msg}`
          })
        })
        .finally(() => {
          // Set loaded and loading = false only after the dependent call finishes
          this.loaded = true
          this.loading = false
        })
    },
    getMetrics: function () {
      this.loading = true // Set loading true for the whole process
      this.loaded = false // Reset loaded state
      HTTP.get(`/alerts/metrics/${this.activeType}/${this.id}/${this.period}`)
        .then((response) => {
          this.metrics = response.data['metrics']
          // Set date here - this will trigger the watch and call getReport
          this.date = response.data['metrics'][11]['date']
          this.lastUpdate = response.data.metrics[11]['last_update'].toString()
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get alert metrics : ${msg}`
          })
          this.loading = false // Stop loading on error
        })
        // Removed .finally() here - loading=false will be set in getReport's finally
    },
    updateMetric: function (event) {
      // This method remains the same as it primarily interacts with MetricGraph
      switch (event.eventType) {
        case 'date':
          this.date = event.data.date
          this.lastUpdate = event.data.lastUpdate.toString()
          // The 'date' watch will trigger getReport
          break

        case 'period':
          this.period = event.data.period
          // The 'period' watch will trigger getMetrics (which then triggers getReport)
          break

        case 'metricProperty':
          this.metricProperty = event.data.metricProperty
          break

        default:
          console.log(event)
          break
      }
    }
  },
  created: function () {
    this.getMetrics() // Initial data fetch starts here
  },
  watch: {
    id: function () {
      this.date = null // Reset date to avoid stale data
      this.getMetrics()
    },
    period: function () {
      // Changing period needs fresh metrics and then report data
      this.getMetrics()
    },
    date: function (newDate, oldDate) {
      // Ensure date is not null and has actually changed before fetching report
      if (newDate != null && newDate !== oldDate) {
        this.getReport()
        // Removed getAllAlerts call
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Cards/InfoCards/AlertsCard.vue